import { render, staticRenderFns } from "./StorageTermsReference.vue?vue&type=template&id=56d83e2b"
import script from "./StorageTermsReference.vue?vue&type=script&lang=js"
export * from "./StorageTermsReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d83e2b')) {
      api.createRecord('56d83e2b', component.options)
    } else {
      api.reload('56d83e2b', component.options)
    }
    module.hot.accept("./StorageTermsReference.vue?vue&type=template&id=56d83e2b", function () {
      api.rerender('56d83e2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/StorageTermsReference.vue"
export default component.exports